import { makeAutoObservable } from 'mobx';
import { CoreRoot } from '../core-logic/CoreRoot';
import { RoutingModule } from './modules/routing/RoutingModule';
import { AuthorizationUIModule } from './modules/authorization-ui/AuthorizationUIModule';
import { IAppLoaderStorage } from '../../infrastructure/types/utils/storage-types';
import { IAppLoaderNavigationService } from '../../infrastructure/types/features/navigation/navigation-types';
import { IAdaptiveService } from '../../infrastructure/types/features/adaptive/adaptive-types';
import { AppTheme, ThemeId } from '../../infrastructure/types/features/themes/theme-types';
import { getDefaultTheme, getThemeById } from '../../../shared/ui/styles/themes/themes';
import { AdaptiveUIModule } from './modules/adaptive/AdaptiveUIModule';

class UIRoot {
  theme: AppTheme = getDefaultTheme();
  private coreRoot: CoreRoot;
  routingModule: RoutingModule;
  authorizationUiModule: AuthorizationUIModule;
  adaptiveUIModule: AdaptiveUIModule;

  constructor(
    coreRoot: CoreRoot,
    navigationService: IAppLoaderNavigationService,
    appStorage: IAppLoaderStorage,
    adaptiveService: IAdaptiveService,
  ) {
    makeAutoObservable(this, {});

    this.coreRoot = coreRoot;
    this.routingModule = new RoutingModule(
      coreRoot,
      this,
      navigationService,
      appStorage,
      this.coreRoot.authorizationModule.currentUser,
    );

    this.authorizationUiModule = new AuthorizationUIModule(
      this.coreRoot.authorizationModule,
      navigationService,
    );

    this.adaptiveUIModule = new AdaptiveUIModule(adaptiveService);

    this.routingModule.initRouter();
  }

  changeTheme(themeID: ThemeId) {
    this.theme = getThemeById(themeID);
  }
}

export { UIRoot };
